import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["time", "onChange", "placeholder", "maxWidth", "t"];
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { withTheme } from '@emotion/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FlyoverBuilder } from '../Flyover/FlyoverBuilder';
import { ArrowDownIcon, ClockIcon } from '../icons';
import { TextInput } from '../TextInput';
import { fromThemeColors } from '../Theme';
import { withTranslate } from '../util';
import { StyledFlyover } from './TimePicker.styled';
import { TimeWidget } from './TimeWidget';
import { getIs24Hr } from './util';
var _TimePicker = /*#__PURE__*/function (_React$Component) {
  function _TimePicker(props) {
    var _this;
    _classCallCheck(this, _TimePicker);
    _this = _callSuper(this, _TimePicker, [props]);
    _defineProperty(_this, "onFocus", function (openFlyover) {
      if (!_this.state.time && !_this.props.disabled && !_this.props.readOnly) {
        _this.setState({
          time: _this.formatTime(new Date())
        });
      }
      openFlyover();
    });
    _defineProperty(_this, "setTime", function (time) {
      _this.setState({
        time: time
      });
    });
    _defineProperty(_this, "saveTime", function () {
      if (!_this.state.time) {
        _this.props.onChange(null);
        return;
      }
      var is24Hr = getIs24Hr();
      var needsMeridiem = !is24Hr && _this.state.time.match(/ [APap][Mm]$/gi);
      var looseFormat = _this.props.timeFormat || "".concat(is24Hr ? 'HH' : 'h', ":mm").concat(needsMeridiem ? ' A' : '');
      var time = dayjs(_this.state.time.toLocaleUpperCase(), looseFormat);
      if (!time.isValid()) {
        _this.updateInputs(_this.dateTime);
        return;
      }
      var newDate = time.toDate();
      newDate.setFullYear(_this.dateTime.getFullYear(), _this.dateTime.getMonth(), _this.dateTime.getDate());
      _this.props.onChange(newDate);
      _this.updateInputs(newDate);
    });
    _defineProperty(_this, "onTimeStepperChange", function (time) {
      _this.props.onChange(time.toDate());
      _this.updateInputs(time.toDate());
    });
    dayjs.extend(relativeTime);
    dayjs.extend(customParseFormat);
    dayjs.extend(localeData);
    dayjs.extend(localizedFormat);
    _this.state = {
      time: _this.formatTime(_this.props.time)
    };
    return _this;
  }
  _inherits(_TimePicker, _React$Component);
  return _createClass(_TimePicker, [{
    key: "dateTime",
    get: function get() {
      return this.props.time || new Date();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var textIconColor = fromThemeColors('secondaryText')(this.props);
      var _this$props = this.props,
        time = _this$props.time,
        onChange = _this$props.onChange,
        placeholder = _this$props.placeholder,
        _this$props$maxWidth = _this$props.maxWidth,
        maxWidth = _this$props$maxWidth === void 0 ? '212px' : _this$props$maxWidth,
        t = _this$props.t,
        textInputProps = _objectWithoutProperties(_this$props, _excluded);
      var flyoverDisabled = textInputProps.disabled || textInputProps.readOnly;
      return /*#__PURE__*/React.createElement(FlyoverBuilder, {
        flyover: /*#__PURE__*/React.createElement(StyledFlyover, null, /*#__PURE__*/React.createElement(TimeWidget, {
          dateTime: dayjs(this.dateTime),
          onChange: this.onTimeStepperChange,
          timeFormat: this.props.timeFormat
        })),
        disabled: flyoverDisabled
      }, function (flyoverProps) {
        var _ref;
        return /*#__PURE__*/React.createElement("div", _extends({}, flyoverProps, {
          style: {
            maxWidth: maxWidth
          }
        }), /*#__PURE__*/React.createElement(TextInput, _extends({}, textInputProps, {
          icon: /*#__PURE__*/React.createElement(ClockIcon, {
            size: 16,
            color: textIconColor
          }),
          secondaryIcon: flyoverDisabled ? undefined : /*#__PURE__*/React.createElement(ArrowDownIcon, {
            size: 16,
            color: textIconColor
          }),
          autoComplete: "off",
          placeholder: (_ref = placeholder || t('citrix-ui:time.select_a_time')) !== null && _ref !== void 0 ? _ref : '',
          maxWidth: maxWidth,
          value: _this2.state.time || '',
          onChange: _this2.setTime,
          onBlur: _this2.saveTime,
          onFocus: function onFocus() {
            return _this2.onFocus(flyoverProps.onClick);
          }
        })));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      var prevTime = prevProps.time;
      var newTime = this.props.time;
      if ((prevTime === null || prevTime === void 0 ? void 0 : prevTime.getHours()) !== (newTime === null || newTime === void 0 ? void 0 : newTime.getHours()) || (prevTime === null || prevTime === void 0 ? void 0 : prevTime.getMinutes()) !== (newTime === null || newTime === void 0 ? void 0 : newTime.getMinutes()) || prevProps.timeFormat !== this.props.timeFormat) {
        this.setState(function (_, props) {
          return {
            time: _this3.formatTime(props.time)
          };
        });
      }
    }
  }, {
    key: "formatTime",
    value: function formatTime(time) {
      if (!time) {
        return '';
      }
      if (this.props.timeFormat) {
        return dayjs(time).locale(getLanguage()).format(this.props.timeFormat);
      }
      var is24Hr = getIs24Hr();
      var exactFormat = "".concat(is24Hr ? 'HH' : 'h', ":mm").concat(is24Hr ? '' : ' A');
      return dayjs(time).locale(getLanguage()).format(exactFormat);
    }
  }, {
    key: "updateInputs",
    value: function updateInputs(time) {
      this.setState({
        time: this.formatTime(time)
      });
    }
  }]);
}(React.Component);
export var TimePicker = withTheme(withTranslate(_TimePicker));